import React from 'react';
import ClientHelpRequests from './ClientHelpRequests';
import { api_srv } from 'services';
import { useQuery } from 'react-query';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';


function ClientRequestHelpContainer(props) {
        const antIcon = <LoadingOutlined style={{ fontSize: 34 }} spin />;

            async function fetch_quotation_requests() {
                let resp = await (await api_srv).get_client_quotation_requests();
                console.log("resp===", resp)
                return resp.data;
            }
        
            const { isLoading, isSuccess, data } = useQuery('client recent requests', fetch_quotation_requests);
            console.log("QR---", data)

    return (
        <>
            {isLoading && <Spin style={{ position: 'absolute', top: '50%', left: '50%' }} indicator={antIcon} />}
            {isSuccess && <ClientHelpRequests data={data} />}
        </>
    );
}

export default ClientRequestHelpContainer;